<div class="wrapperSideBar">
  <div class="wrapperSideBar__bg" (click)="toggleModal.emit()"></div>
  <div class="wrapperSideBar__box slideInRight animated">
    <div class="wrapperSideBar__content">
      <div class="wrapperSideBar__content-header" *ngIf="showHeader">
        <h2>{{title}}</h2>
        <span (click)="toggleModal.emit()"><i aria-hidden="true" class="icon-close"></i></span>
      </div>
      <div class="wrapperSideBar__content-body">
        <h3 *ngIf="showSubTitle">{{subTitle}}</h3>
        <ng-content select="[content]"></ng-content>
      </div>
      <div class="wrapperSideBar__content-footer">
        <ng-content select="[footer]"></ng-content>
      </div>
    </div>
  </div>
</div>
